import React, { useState } from "react";
import { Container, Row, Col, Image, Carousel, Modal } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import _ from "lodash";
import {
  getImageURLMapping,
  getImageURL
} from "../../util/candidateDataFilters";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "../../styles/attachments.css";
import CDKSpinner from "../../images/CDKSpinner.gif";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const ViewUserDocuments = ({
  userDocuments,
  setUserDocuments,
  isAdmin = false
}) => {
  const [show, handleShow] = useState(false);
  const [showPdf, handleShowPdf] = useState(false);
  const [index, setIndex] = useState(0);
  const [pdfView, setPdfView] = useState([]);
  const [numPages, setNumPages] = useState(0);

  const handleClose = () => {
    handleShow(false);
    handleShowPdf(false);
  };
  const handleOpen = file => {
    const index = _.findIndex(getImageFiles(), i => i.name === file.name);
    handleShow(true);
    setIndex(index);
  };
  let imageURLMapping = getImageURLMapping(userDocuments);
  const deletePhoto = photo => {
    let updatedDocuments = _.remove(userDocuments, file => {
      return file.name !== photo.name;
    });
    URL.revokeObjectURL(getImageURL(imageURLMapping, photo));
    imageURLMapping = _.remove(imageURLMapping, file => {
      return file.name !== photo.name;
    });
    setUserDocuments(updatedDocuments);
  };

  const setPdf = pdf => {
    setPdfView(pdf);
    handleShowPdf(true);
  };

  const deletePdf = pdf => {
    userDocuments = _.remove(userDocuments, file => {
      return file.name !== pdf.name;
    });
    setUserDocuments(userDocuments);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  const getImageFiles = () => {
    return userDocuments.length
      ? userDocuments
          .filter(document => document.type !== "application/pdf")
          .map(image => ({
            url: getImageURL(imageURLMapping, image),
            name: image.name
          }))
      : [];
  };
  return (
    <Container className="pt-4">
      <Row>
        <Col xs={6} md={12}>
          <div className="thumbnails-view pb-4">
            {userDocuments.length > 0 &&
              userDocuments.map((file, i) => {
                if (file.type !== "application/pdf") {
                  const url = getImageURL(imageURLMapping, file);
                  return (
                    <div className="image-area">
                      <div>
                        <img
                          src={url}
                          onClick={() => {
                            handleOpen(file);
                          }}
                          alt="..."
                          className="thumbnail img-responsive border rounded border-dark m-1 p-1"
                        />
                        <div class="caption center-block text-center text-wrap">
                          {file.name.length > 20
                            ? file.name.substring(0, 17) + "..."
                            : file.name}
                        </div>
                      </div>
                      {!isAdmin && (
                        <button
                          type="button"
                          class="close"
                          aria-label="Close"
                          onClick={() => deletePhoto(file)}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div className="image-area">
                      <div>
                        <div
                          className="thumb-pdf border rounded border-dark m-1 p-1"
                          onClick={() => {
                            setPdf(file);
                          }}
                        >
                          <Document
                            file={file}
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading={<img src={CDKSpinner} alt="loading" />}
                          >
                            <Page pageNumber={1} />
                          </Document>
                        </div>
                        <div class="caption center-block text-center text-wrap">
                          {file.name.length > 12
                            ? file.name.substring(0, 11) + "..."
                            : file.name}
                        </div>
                      </div>
                      {!isAdmin && (
                        <button
                          type="button"
                          class="close"
                          aria-label="Close"
                          onClick={() => deletePdf(file)}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      )}
                    </div>
                  );
                }
              })}
            <br />
          </div>
        </Col>
      </Row>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-center"
        centered
        show={show}
        onHide={handleClose}
        animation
      >
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Carousel
            interval={19000}
            keyboard={false}
            pauseOnHover={true}
            activeIndex={index}
            onSelect={handleSelect}
          >
            {(getImageFiles() || []).map((file, i) => (
              <Carousel.Item>
                <Image
                  className="d-block carousel-img img-responsive"
                  src={file.url}
                  alt={file.name}
                  rounded
                />
                <Carousel.Caption>
                  <p>{file.name}</p>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-center"
        centered
        show={showPdf}
        onHide={handleClose}
        animation
      >
        <Modal.Header className="sticky-top" closeButton>
          <Modal.Title>{pdfView && pdfView.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Document
            file={pdfView}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<img src={CDKSpinner} alt="loading" />}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <>
                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                <p className="text-center">
                  Page {index + 1} of {numPages}
                </p>
                {index + 1 !== numPages && <hr />}
              </>
            ))}
          </Document>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Container>
  );
};
export default ViewUserDocuments;
